import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = customSetting.projMgmtController;
const getProjMgmtController = self.customSetting.getProjMgmtController;
const postProjMgmtController = self.customSetting.postProjMgmtController;

export default {
  // 1-6
  getNewBillNo: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getProjMgmtController}/NewBillNo`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getSupplier2: (context, obj) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getProjMgmtController}/GetSupplier2?s_name=${obj.query}&location_id=${obj.id}&prjNo=${obj.prjNo}`
        )
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  addNewProjectApplication(context, data) {
    const formData = new FormData(); //一定要用FormData() 或者<form></form>

    Object.entries(data).forEach(([key, value]) => {
      if (value) {
        //一定要判斷,不然會變成"null"
        if (Array.isArray(value)) {
          // 如果是array 要特別處理
          value.forEach((item) => {
            formData.append(key, item);
          });
        } else {
          formData.append(key, value);
        }
      }
    });

    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postProjMgmtController}/InsApproval`, formData, {
          //一定要指定
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getSigner: (context, query) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getProjMgmtController}/GetSigner?word=${query}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getEditSigner: (context, obj) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getProjMgmtController}/GetSigner?word=${obj.query}&prjNo=${obj.prjNo}`
        )
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getSupplier: (context, obj) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getProjMgmtController}/GetSupplier1?s_name=${obj.query}&location_id=${obj.id}`
        )
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  // 1-7
  getEngineeringData: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getProjMgmtController}/GetProjList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  switchEngineeringData: (context, prjNo) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postProjMgmtController}/ChgStateProject`, {
          prjNo: prjNo,
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getProjDetail: (context, prjNo) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getProjMgmtController}/GetProjDetail?prjNo=${prjNo}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  addChgStateProject: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postProjMgmtController}/ModifyProjInfo`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getModifyProjInfo: (context, obj) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getProjMgmtController}/GetModifyProjInfo?prjNo=${obj.prjNo}&Id=${obj.id}`
        )
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  // 1-8
  getSignOffDoc: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getProjMgmtController}/SignOffList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  getSignOffHistory: (context, prjNo) => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseApi}/${getProjMgmtController}/SignOffHistory?prjNo=${prjNo}`
        )
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
};
